import { ListedUser } from './types';

export interface AssignableCurrentUser {
  emailAddress?: string;
  hasProfilePicture?: boolean;
  id?: string;
  modifiedAt?: Date | string;
  name?: string;
}

export const withCurrentAssignableUser = (
  users: ListedUser[] | undefined,
  currentUser?: AssignableCurrentUser | null,
): ListedUser[] => {
  const byId = new Map<string, ListedUser>();
  (users || []).forEach(user => {
    if (user?.id) {
      byId.set(user.id, user);
    }
  });

  if (currentUser?.id && !byId.has(currentUser.id)) {
    byId.set(currentUser.id, {
      createdAt: new Date(0),
      emailAddress: currentUser.emailAddress || '',
      hasProfilePicture: currentUser.hasProfilePicture,
      id: currentUser.id,
      modifiedAt: currentUser.modifiedAt
        ? new Date(currentUser.modifiedAt)
        : undefined,
      name: currentUser.name || currentUser.emailAddress || '',
    });
  }

  const currentUserId = currentUser?.id;
  return [...byId.values()].sort((a, b) => {
    if (currentUserId && a.id === currentUserId) {
      return -1;
    }
    if (currentUserId && b.id === currentUserId) {
      return 1;
    }
    return (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase());
  });
};

export const assigneeDisplayName = (user: Pick<ListedUser, 'emailAddress' | 'name'>) => (
  user.name || user.emailAddress
);

const normalizeAssigneeId = (assignee?: string | null) => assignee || null;

export const sharedAssigneeId = (
  items: Array<{ assignee?: string | null }>,
): string | undefined => {
  if (!items.length) {
    return undefined;
  }
  const first = normalizeAssigneeId(items[0].assignee);
  if (!first || items.some(item => normalizeAssigneeId(item.assignee) !== first)) {
    return undefined;
  }
  return first;
};
